export default __webpack_public_path__ + "static/media/ApexgramNative.3a895475.mp4";